import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5df39f28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pl-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Select a Protocol:")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = { class: "flex xs1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "flex row pt-2"
}
const _hoisted_8 = { class: "flex xs12 sm8 md6" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Vote for this Protocol!")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" This protocol has not joined up with Notifi yet. Click to Vote and help encourage them to share News and Information here! ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Vote")
const _hoisted_12 = {
  key: 1,
  class: "flex row pt-2"
}
const _hoisted_13 = { class: "row pt-2" }
const _hoisted_14 = { class: "flex xs12 sm8 md6" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("About these Alerts:")
const _hoisted_16 = ["innerHTML"]

import ProtocolSelector from "./ProtocolSelector.vue";
import ProtocolInfo from "./ProtocolInfo.vue";
import { Subscription } from "@/models/Subscription";
import {
  SubscriptionType,
  SubscriptionTypeStatus,
} from "@/models/SubscriptionType";
import { Protocol } from "@/models/Protocol";
import { inject, computed, ref, watch } from "vue";
import Moralis from "moralis";
import { NotifiUser } from "@/models/NotifiUser";
import { useRoute } from "vue-router";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  subscription: { type: Subscription, required: false },
  protocol: { type: Protocol, required: false },
  subscriptionID: { type: String, required: false },
},
  emits: ["changed"],
  async setup(__props, { expose, emit }) {

let __temp: any, __restore: any

const props = __props


// eslint-disable-next-line no-undef

const route = useRoute();

const fetchBySubscriptionID = async (subID: string): Promise<Subscription> => {
  fetching.value = true;
  const sub = await Subscription.fetch(subID);
  if (sub) {
    activeSubscription.value = sub;
    const prot: Protocol = sub.protocol;
    await prot.fetch();
    intSelectedProtocol.value = prot;
    console.log(sub.generalType);
    intSubGeneralType.value = sub.generalType;
    fetching.value = false;
    return sub;
  }
  throw "Invalid Subscription ID";
};

const intSelectedProtocol = ref<Protocol | undefined>(props.protocol);
const subGeneralTypes = ref<SubscriptionType[]>([]);
const fetching = ref(false);
const intSubGeneralType = ref<SubscriptionType | undefined>();
const activeSubscription = ref<Subscription>();

const selectedSubGeneralType = computed({
  get(): SubscriptionType | undefined {
    return intSubGeneralType.value;
  },
  set(val: SubscriptionType | undefined): void {
    if (val) {
      const t = subGeneralTypes.value.find((e) => e.id == val.id);
      intSubGeneralType.value = t;
    } else {
      intSubGeneralType.value = val;
    }
    emit("changed");
  },
});

const selectedProtocol = computed({
  get(): Protocol | undefined {
    return intSelectedProtocol.value;
  },
  set(val: Protocol | undefined): void {
    intSelectedProtocol.value = val;
    emit("changed");
  },
});
const selectedSubGeneralTypeName = computed((): string | undefined => {
  const t = selectedSubGeneralType.value;
  return t?.name;
});

const protocolNoTypes = computed(() => {
  return fetching.value == false && subGeneralTypes.value.length == 0;
});

const selectedSubGeneralTypeDescription = computed((): string | undefined => {
  if (protocolNoTypes.value) {
    return "";
  }
  const t = selectedSubGeneralType.value;
  return t?.description;
});

const fetchSubGeneralTypes = async (): Promise<void> => {
  fetching.value = true;
  const q = new Moralis.Query(SubscriptionType);
  q.equalTo("protocol", selectedProtocol.value);
  q.equalTo("status", SubscriptionTypeStatus.active);
  const res = await q.find();
  //selectedSubGeneralType.value = undefined;
  subGeneralTypes.value.length = 0;
  subGeneralTypes.value.push(...res);
  fetching.value = false;
};

const irrigate = (s: Subscription): void => {
  if (selectedSubGeneralType.value != undefined)
    s.category = selectedSubGeneralType.value;
  if (selectedProtocol.value != undefined) s.protocol = selectedProtocol.value;
};

const message = computed((): string => {
  const info = selectedSubGeneralTypeName.value || "[Select a Type above]";
  return `the <strong>${selectedProtocolName.value}</strong> Protocol about <strong>${info}</strong>`;
});

const validSubmit = computed((): boolean => {
  return (
    selectedProtocolName.value != "" &&
    selectedSubGeneralType.value != undefined
  );
});

const canComplete = computed((): boolean => {
  return protocolNoTypes.value != true;
});

// eslint-disable-next-line no-undef
expose({ irrigate, message, validSubmit, canComplete });

const selectedProtocolName = computed((): string => {
  const p = intSelectedProtocol.value;
  if (!p) {
    return "";
  } else {
    return p.name;
  }
});

const clearProtocol = () => {
  selectedProtocol.value = undefined;
};
const selectProtocol = (prot: Protocol) => {
  selectedProtocol.value = prot;
};
const voteFor = async (): Promise<void> => {
  if (!selectedProtocol.value) return undefined;
  const newVotes = await selectedProtocol.value.siteVote();
  //this.$forceUpdate();
};

watch(selectedProtocol, async (newProt, oldProt) => {
  fetchSubGeneralTypes();
});

if (route.query.protocolID) {
  fetching.value = true;
  selectedProtocol.value = (
  ([__temp,__restore] = _withAsyncContext(() => Protocol.fetch(
    route.query.protocolID as string
  ))),
  __temp = await __temp,
  __restore(),
  __temp
);
}
if (props.subscriptionID) {
  (
  ([__temp,__restore] = _withAsyncContext(() => fetchBySubscriptionID(props.subscriptionID))),
  await __temp,
  __restore()
);
}

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_card_actions = _resolveComponent("va-card-actions")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_select = _resolveComponent("va-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(ProtocolSelector, {
          showSearch: true,
          showUserInfo: true,
          onSelection: selectProtocol
        })
      ], 512), [
        [_vShow, !_unref(selectedProtocol)]
      ]),
      (_unref(selectedProtocol))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(ProtocolInfo, {
              protocol: _unref(selectedProtocol),
              selected: false,
              showVote: false,
              showUserInfo: true,
              showFavorites: true,
              allowSelect: false,
              showSubscribe: false,
              displayMode: "narrow"
            }, null, 8, ["protocol"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_va_button, {
                onClick: clearProtocol,
                size: "small",
                color: "secondary",
                icon: "clear",
                class: "float-right"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_va_divider, { inset: "" }),
    (_unref(selectedProtocol))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_unref(protocolNoTypes))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_va_card, { bordered: false }, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_card_title, null, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_va_card_content, null, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_va_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_popover, {
                            color: "primary",
                            message: "Request support for this Protocol on Notifi"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_va_button, {
                                size: "large",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (voteFor(__props.protocol)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_va_select, {
                  class: "flex xs12 sm8 md6 lg3",
                  label: "Subscription Category",
                  modelValue: _unref(selectedSubGeneralType),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedSubGeneralType) ? (selectedSubGeneralType).value = $event : null)),
                  options: subGeneralTypes.value,
                  "track-by": "id",
                  "text-by": "name",
                  rules: [
          (selectedSubGeneralType) =>
            selectedSubGeneralType != null || 'Select an alert category',
        ]
                }, null, 8, ["modelValue", "options", "rules"]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_va_card, { bordered: false }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_card_title, null, {
                          default: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_va_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              innerHTML: this.selectedSubGeneralTypeDescription
                            }, null, 8, _hoisted_16)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})